import { List } from 'immutable';
import { loanReceivedConstants } from '../constants';

export function loans_received(state = {}, action) {
  switch (action.type) {
    case loanReceivedConstants.LOAN_RECEIVED_LIST_LOADING:
      return {
        ...state,
        listLoading: true
      };
    case loanReceivedConstants.LOAN_RECEIVED_LIST_SUCCESS:
      return {
        ...state,
        items: List(action.response),
        listLoading: false
      };
    case loanReceivedConstants.LOAN_RECEIVED_LIST_FAILURE:
      return {
        ...state,
        listLoading: false,
        items: [],
        listError: action.error
      };

    case loanReceivedConstants.LOAN_RECEIVED_LIST_CLEAR:
      return {
        ...state,
        items: null
      };

    case loanReceivedConstants.LOAN_RECEIVED_CREATE_LOADING:
      return {
        ...state,
        createLoading: true
      };
    case loanReceivedConstants.LOAN_RECEIVED_CREATE_SUCCESS: {
      const items = state.items ? state.items : List();
      return {
        ...state,
        items: items.push(action.response),
        createLoading: false,
        createError: null
      };
    }
    case loanReceivedConstants.LOAN_RECEIVED_CREATE_FAILURE:
      return {
        ...state,
        createLoading: false,
        createError: action.error
      };

    case loanReceivedConstants.LOAN_RECEIVED_EDIT_LOADING:
      return {
        ...state,
        editLoading: true
      };
    case loanReceivedConstants.LOAN_RECEIVED_EDIT_SUCCESS: {
      if (!state.items) {
        return state;
      }

      const loanReceivedIndex = state.items.findIndex(val => val.id == action.response.id);

      if (loanReceivedIndex == -1) {
        return state;
      }

      return {
        ...state,
        items: state.items.set(loanReceivedIndex, action.response),
        editLoading: false,
        editError: null
      };
    }
    case loanReceivedConstants.LOAN_RECEIVED_EDIT_FAILURE:
      return {
        ...state,
        editLoading: false,
        editError: action.error
      };

    case loanReceivedConstants.LOAN_RECEIVED_DELETE_LOADING:
      return {
        ...state,
        deleteLoading: true
      };
    case loanReceivedConstants.LOAN_RECEIVED_DELETE_SUCCESS: {
      const { loanReceivedId } = action;

      if (!state.items) {
        return state;
      }

      const loanReceivedIndex = state.items.findIndex(val => val.id == loanReceivedId);

      if (loanReceivedIndex == -1) {
        return state;
      }

      return {
        ...state,
        items: state.items.delete(loanReceivedIndex),
        deleteLoading: false,
        deleteError: null
      };
    }
    case loanReceivedConstants.LOAN_RECEIVED_DELETE_FAILURE:
      return {
        ...state,
        deleteLoading: false,
        deleteError: action.error
      };

    case loanReceivedConstants.LOAN_RECEIVED_ERROR_RELOAD:
      return {
        ...state,
        createError: null,
        editError: null
      };

    case loanReceivedConstants.LOAN_RECEIVED_SYNC_LOADING:
      return {
        ...state,
        syncLoading: true,
        syncError: null
      };
    case loanReceivedConstants.LOAN_RECEIVED_SYNC_SUCCESS:
      return {
        ...state,
        syncLoading: false,
        syncError: null
      };
    case loanReceivedConstants.LOAN_RECEIVED_SYNC_FAILURE:
      return {
        ...state,
        syncLoading: false,
        syncError: action.error
      };
    default:
      return state;
  }
}
